export const stateToRegionByName = {
    Alabama: { epaRegion: 4, code: 'AL' },
    Alaska: { epaRegion: 10, code: 'AK' },
    Arizona: { epaRegion: 9, code: 'AZ' },
    Arkansas: { epaRegion: 6, code: 'AR' },
    California: { epaRegion: 9, code: 'CA' },
    Colorado: { epaRegion: 8, code: 'CO' },
    Connecticut: { epaRegion: 1, code: 'CT' },
    Delaware: { epaRegion: 3, code: 'DE' },
    'District of Columbia': { epaRegion: 3, code: 'DC' },
    Florida: { epaRegion: 4, code: 'FL' },
    Georgia: { epaRegion: 4, code: 'GA' },
    Hawaii: { epaRegion: 10, code: 'HI' },
    Idaho: { epaRegion: 10, code: 'ID' },
    Illinois: { epaRegion: 5, code: 'IL' },
    Indiana: { epaRegion: 5, code: 'IN' },
    Iowa: { epaRegion: 7, code: 'IA' },
    Kansas: { epaRegion: 7, code: 'KS' },
    Kentucky: { epaRegion: 4, code: 'KY' },
    Louisiana: { epaRegion: 6, code: 'LA' },
    Maine: { epaRegion: 1, code: 'ME' },
    Maryland: { epaRegion: 3, code: 'MD' },
    Massachusetts: { epaRegion: 1, code: 'MA' },
    Michigan: { epaRegion: 5, code: 'MI' },
    Minnesota: { epaRegion: 5, code: 'MN' },
    Mississippi: { epaRegion: 4, code: 'MS' },
    Missouri: { epaRegion: 7, code: 'MO' },
    Montana: { epaRegion: 8, code: 'MT' },
    Nebraska: { epaRegion: 7, code: 'NE' },
    Nevada: { epaRegion: 9, code: 'NV' },
    'New Hampshire': { epaRegion: 1, code: 'NH' },
    'New Jersey': { epaRegion: 3, code: 'NJ' },
    'New Mexico': { epaRegion: 9, code: 'NM' },
    'New York': { epaRegion: 2, code: 'NY' },
    'North Carolina': { epaRegion: 4, code: 'NC' },
    'North Dakota': { epaRegion: 8, code: 'ND' },
    Ohio: { epaRegion: 5, code: 'OH' },
    Oklahoma: { epaRegion: 6, code: 'OK' },
    Oregon: { epaRegion: 10, code: 'OR' },
    Pennsylvania: { epaRegion: 3, code: 'PA' },
    'Puerto Rico': { epaRegion: 7, code: 'PR' },
    'Rhode Island': { epaRegion: 1, code: 'RI' },
    'South Carolina': { epaRegion: 4, code: 'SC' },
    'South Dakota': { epaRegion: 8, code: 'SD' },
    Tennessee: { epaRegion: 4, code: 'TN' },
    Texas: { epaRegion: 6, code: 'TX' },
    Utah: { epaRegion: 10, code: 'UT' },
    Vermont: { epaRegion: 1, code: 'VT' },
    Virginia: { epaRegion: 3, code: 'VA' },
    Washington: { epaRegion: 10, code: 'WA' },
    'West Virginia': { epaRegion: 3, code: 'WV' },
    Wisconsin: { epaRegion: 5, code: 'WI' },
    Wyoming: { epaRegion: 8, code: 'WY' },
  }
  